import { FunctionComponent } from 'react';

import './card-container-list-item.scss';


export interface CardContainerListItemProps {
	/**
	 * (Optional) Disabled state
	 */
	disabled?: boolean;
	/**
	 * (Optional) Archived state
	 */
	archived?: boolean;
}

/**
 * The container list item card component
 */
export const CardContainerListItem: FunctionComponent<CardContainerListItemProps> = (props): JSX.Element => {
	const { disabled, children, archived = false } = props;

	const componentDisabledStyle = disabled ?
		' card-container-list-item--disabled' :
		'';

	const componentArchivedStyle = archived ?
		' card-container-list-item--archived' :
		'';

	return (
		<div className={`card-container-list-item${componentDisabledStyle}${componentArchivedStyle}`}>
			<div
				className='card-container-list-item__content'
				role='button'
				tabIndex={0}
			>
				{children}
			</div>
		</div>
	);
};
